export const LEFT_NAVIGATION = [
	{
		title: 'Getting Started',
		href: '',
		anchors: [
			// {title: 'Base URL'},
			// {title: 'Headers'},
			// {title: 'Paging'},
			// {title: 'Created'},
		]
	},
	{
		title: 'Models',
		href: '/models',
		anchors: [
			// {title: 'List'},
			// {title: 'User'},
			// {title: 'Location'},
			// {title: 'Post'},
			// {title: 'Comment'},
			// {title: 'Tag'},
		]
	},
	{
		title: 'User Data',
		href: '/user',
		anchors: []
	},
	{
		title: 'Post Data', href: '/post', anchors: []
	},
	{
		title: 'Comment Data', href: '/comment', anchors: []
	},
	{
		title: 'Tag Data', href: '/tag', anchors: []
	},
	{
		title: 'Errors', href: '/errors', anchors: []
	},
];